module.exports = __webpack_public_path__ + "media/flags/ls-a9440b7f.svg";